import { NAME as PARENT_NAME, ROUTES as PARENT_ROUTES } from '../constants';

export const NAME = `${PARENT_NAME}/VIEW`;

export const REDUCER_NAME = 'viewManifest';

export const FORM_NAME = NAME;

export const ROUTES = {
  ROOT: `${PARENT_ROUTES.ROOT}/view/:id`,
};

// const EDGE = 'https://ad3d55af-4b63-4c60-8c3c-38464f072b2e.mock.pstmn.io';
const EDGE = SHIPPING_EDGE;

export const API = {
  ORDER: `${EDGE}/api/manifest/order/:id`,
  ORDER_DETAILS: `${EDGE}/api/manifest/order/:id/details`,
  ALL_ORDER_DETAILS: `${EDGE}/api/manifest/order/:id/all-details`,
};
